import { Link, useNavigate } from "react-router-dom";
import GridView from "../../components/controls/GridView/GridView";
import accountMarketerService from "../../services/accountMarketerService";
import { MenuItem } from "../../models/menu";
import { AccountMarketer } from "../../models/interfaces";
import { useEffect, useState } from "react";
import SearchBar from "../../components/controls/SearchBar/SearchBar";
import FormModal from "../../components/controls/FormModal/FormModal";
import FormCommand from "../../components/controls/FormCommand";
import Frame from "../../components/controls/Frame/Frame";
import ContextMenu from "../../components/controls/ContextMenu/ContextMenu";
export interface AccountMarketersProps {
  isModal?: boolean;
}

export const AccountMarketers = (props: AccountMarketersProps) => {
  const navigate = useNavigate();
  const [marketers, setMarketers] = useState<AccountMarketer[]>([]);
  const [marketer, setMarketer] = useState<AccountMarketer>();
  const [currentPage, setCurrentPage] = useState(1);

  const menuItems: MenuItem<AccountMarketer>[] = [
    {
      onClick: (marketer) => {
        alert(marketer.name);
      },
      name: "Edit",
    },
    {
      name: "Delete",
      onClick: (marketer) => {
        alert("Delete " + marketer.name);
      },
    },
    {
      name: "Disable / Enable",
      onClick: (marketer) => {
        alert("Disabled or enabled" + marketer.name);
      },
    },
  ];

  const getMarketers = async (marketerName: string) => {
    const res = await accountMarketerService.getMarketers({
      pageIndex: currentPage,
      recordCount: 10,
      name: marketerName,
    });

    if (res.status) {
      setMarketers(res.data ?? []);
    }
  };

  useEffect(() => {
    getMarketers("");
  });

  const saveMarketer = async () => {
    const res = await accountMarketerService.addOrUpdateMarkter(
      { name: marketer?.name ?? "" },
      marketer?.id ?? 0
    );

    if (res.status) {
      alert(res.message);
      if (marketers !== undefined) {
        setMarketers([...marketers, res.data as AccountMarketer]);
        return;
      }
    }

    alert(res.message);
  };

  return (
    <div className="row">
      <div className="col">
        <Frame>
          <h4>Account Marketers</h4>
          <GridView
            keys={["name"]}
            name={"lstAccountOfficers"}
            rowsPerPage={50}
            showSearchBar={true}
            showAddButton={true}
            onAddRecord={() => setMarketer({})}
          >
            <GridView.Header>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Action(s)</th>
                </tr>
              </thead>
            </GridView.Header>
            <GridView.Content>
              {marketers.map((d) => (
                <tr>
                  <td>{d.name}</td>
                  <td>{d.email}</td>
                  <td>{d.phone}</td>
                  <td>
                    <ContextMenu menu={menuItems} item={d} />
                  </td>
                </tr>
              ))}
            </GridView.Content>
          </GridView>

          {marketer && (
            <FormModal onClose={() => setMarketer(undefined)}>
              <AccountMarketerForm />
            </FormModal>
          )}
        </Frame>
      </div>
    </div>
  );
};

export interface AccountMarketerFormProps {}

export function AccountMarketerForm(props: AccountMarketerFormProps) {
  return (
    <div className="row">
      <div className="col">
        <div className="form-group">
          <label htmlFor="marketerName" className="control-label">
            Marketer Name
          </label>
          <input
            type="text"
            name="marketerName"
            id="marketerName"
            placeholder="Enter name of marketer"
            className="form-control"
          />
        </div>

        <FormCommand />
      </div>
    </div>
  );
}
